module.exports = __webpack_public_path__ + "static/media/emptypage.48ca6504.png";